import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';
import { LabelErrorsState } from '../types';

const initialState: LabelErrorsState = {
  results: [],
};

export default function labelErrors(
  state = initialState,
  action: RootActionTypes,
): LabelErrorsState {
  switch (action.type) {
    case ActionTypes.LABEL_ERRORS_REQUEST:
      return initialState;
    case ActionTypes.LABEL_ERRORS_SUCCESS:
      return {
        results: action.payload,
      };
    case ActionTypes.LABEL_ERRORS_FAILURE:
      return {
        ...initialState,
        error: action.payload,
      };
    default:
      return state;
  }
}
